import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RenameYourAccountService {

	constructor(private http: HttpClient) { }

	renameAccount(renameAccountData: any): Observable<any> {

		const name = renameAccountData.accountName;

		const dataRenameAccount = {
			nomeConta: name
		};

		return this.http.put( endpoints.accounts.rename , dataRenameAccount);

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-your-account.service.ts